
export enum WorkwearIssuedBy {
  client = 'CLIENT',
  agency = 'AGENCY',
}
